// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uh-0";
export var checkoutRateBadgeLink = "_uh-1";